/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Scenario options for scenario selection dropdown
 * @export
 * @interface InternalApiScenarioOption
 */
export interface InternalApiScenarioOption {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioOption
     */
    handle: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioOption
     */
    active: boolean;
}

/**
 * Check if a given object implements the InternalApiScenarioOption interface.
 */
export function instanceOfInternalApiScenarioOption(value: object): value is InternalApiScenarioOption {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function InternalApiScenarioOptionFromJSON(json: any): InternalApiScenarioOption {
    return InternalApiScenarioOptionFromJSONTyped(json, false);
}

export function InternalApiScenarioOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioOption {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'handle': json['handle'],
        'active': json['active'],
    };
}

export function InternalApiScenarioOptionToJSON(json: any): InternalApiScenarioOption {
    return InternalApiScenarioOptionToJSONTyped(json, false);
}

export function InternalApiScenarioOptionToJSONTyped(value?: InternalApiScenarioOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'handle': value['handle'],
        'active': value['active'],
    };
}

